import { useState, useEffect, useContext } from "react";

import { ZeosApiContext } from "../context/ZeosApiContext";
import { IIncentiveContract } from "../services/zeos-api/contracts/Incentive";

export function useIncentivesByProperty(
  selectedPropertyId: number | null,
  updateSummary?: boolean
) {
  const data = useContext(ZeosApiContext);
  const [rawIncentives, setIncentives] = useState<IIncentiveContract[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [refreshCounter, setRefreshCounter] = useState(0);

  const refresh = () => {
    setRefreshCounter((prev) => prev + 1);
  };

  useEffect(() => {
    if (!selectedPropertyId) {
      setIncentives([]);
      return;
    }

    const fetchIncentives = async () => {
      setLoading(true);
      setError(null);

      try {
        const res = await data.Incentive.eligibleIncentivesByPropertyId(
          selectedPropertyId,
          updateSummary
        );
        setIncentives(res.data || []);
      } catch (err: any) {
        console.error("Failed to fetch incentives", err);
        setError("Could not load incentives");
        setIncentives([]);
      } finally {
        setLoading(false);
      }
    };

    fetchIncentives();
  }, [selectedPropertyId, updateSummary, data, refreshCounter]);

  return { rawIncentives, loading, error, refresh };
}
